import { getEmptyTranslations } from '@/configuration/pages/ConfigurationPage/helpers'

export const getWidgetPayload = (data, supportedLanguages) => {
  const emptyTranslations = getEmptyTranslations(supportedLanguages)
  const text = data?.useCustomText ? data.customTexts : emptyTranslations

  return {
    background_color: data.backgroundColor,
    text_color: data.textColor,
    link_color: data.linkColor,
    show_custom_text: data.useCustomText,
    text,
  }
}
